exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom_button[data-v-33a8877a]{padding:0 20px;position:fixed;width:100%}", ""]);

// exports
